import {
  TextField,
  inputBaseClasses,
  outlinedInputClasses,
  styled,
} from "@mui/material"
import {
  FILTER_FIELD_HEIGHT,
  filterFieldActiveBorderColor,
  filterFieldBorderColor,
} from "./filterField.conf"

export const FilterFieldTextField = styled(TextField)(({ theme: { palette } }) => ({
  [`& .${inputBaseClasses.root}`]: {
    color: palette.common.darkBlue,
    height: "100%",
    minHeight: FILTER_FIELD_HEIGHT,
    borderRadius: "100px",
  },
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: filterFieldBorderColor(palette),
  },
  [`& .${outlinedInputClasses.root}:hover .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: filterFieldActiveBorderColor(palette),
    },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: filterFieldActiveBorderColor(palette),
      borderWidth: 1,
    },
})) as typeof TextField
